// extracted by mini-css-extract-plugin
var _1 = "SeasonalPlanCard_planDisclaimer__-1cNf";
var _2 = "SeasonalPlanCard_planSubTitle__1uhDa";
export { _1 as "planDisclaimer", _2 as "planSubTitle" }
